import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function StackedCell({
  primary,
  secondary,
  primaryClassName,
  secondaryClassName,
  className,
}: {
  primary: ReactNode;
  secondary?: ReactNode;
  primaryClassName?: string;
  secondaryClassName?: string;
  className?: string;
}) {
  if (secondary == null || secondary === "" || secondary === "—") {
    return (
      <div className={cn("min-w-0", className)}>
        <div className={cn("truncate", primaryClassName)}>{primary}</div>
      </div>
    );
  }

  return (
    <div className={cn("space-y-0.5 min-w-0", className)}>
      <div className={cn("truncate", primaryClassName)}>{primary}</div>
      <div
        className={cn(
          "text-xs text-muted-foreground truncate",
          secondaryClassName
        )}
      >
        {secondary}
      </div>
    </div>
  );
}
